/**
 * Collect image files from a paste/drop clipboard payload once.
 * Prefer DataTransferItemList; only fall back to files when items had no images,
 * so the same screenshot is not queued twice.
 */
export function collectClipboardImages(data: {
  items?: DataTransferItemList | null;
  files?: FileList | null;
}): File[] {
  const fromItems: File[] = [];
  for (const item of Array.from(data.items ?? [])) {
    if (!item.type.startsWith("image/")) continue;
    const file = item.getAsFile();
    if (file) fromItems.push(file);
  }
  if (fromItems.length > 0) {
    return fromItems;
  }
  return Array.from(data.files ?? []).filter((file) => file.type.startsWith("image/"));
}
